/**
 @typedef PaymentResource
 @type {Object}
 @property {function(object, object, function, function)} store
 */

/**
 * @param $resource
 * @param apiRequestParams
 * @param {AppConfig} appConfig
 */
const PaymentResource = function ($resource, apiRequestParams, appConfig) {
    return $resource(
        appConfig.apiBaseUrl + 'payments/:id',
        apiRequestParams.defaults(),
        {
            store: {
                method: 'POST',
                url: appConfig.apiBaseUrl + 'payments',
            },
            findByOrderID: {
                isArray: true,
                params: {
                    resolve: 'paymentmethods',
                },
                method: 'GET',
                url: appConfig.apiBaseUrl + 'payments',
            },
        }
    );
};

module.exports = PaymentResource;
